/* ============================================================
   Cart drawer discount code — apply/remove logic + summary
   Theme: Flex (Out of the Sandbox) | CornerCart replacement

   Uses event delegation on document, so it keeps working when
   the drawer's ajax template is re-rendered.

   Apply strategy:
     1. POST /cart/update.js { discount: CODE }  (modern Cart API)
     2. Verify via /cart.js -> discount_codes[].applicable
     3. Fallback: GET /discount/CODE (legacy cookie method,
        applies at checkout) and re-verify.

   On success, updates the drawer summary (chips, subtotal,
   discount row, total). The free shipping bar updates itself
   automatically (its fetch hook sees the /cart/update.js call).
   ============================================================ */
(function () {
  'use strict';

  function moneyFormat() {
    var el = document.querySelector('[data-fsb]');
    return el ? (el.getAttribute('data-fsb-money-format') || '') : '';
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (format && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace(/,/g, ' ').replace(/\./g, ',').replace(/ /g, '.'))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
    }
    return '$' + withDecimals;
  }

  function escapeHtml(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function setMsg(text, state) {
    var msgs = document.querySelectorAll('[data-dc-message]');
    for (var i = 0; i < msgs.length; i++) {
      msgs[i].textContent = text || '';
      msgs[i].classList.toggle('is-success', state === true);
      msgs[i].classList.toggle('is-error', state === false);
    }
  }

  function setBusy(busy) {
    var btns = document.querySelectorAll('[data-dc-apply]');
    for (var i = 0; i < btns.length; i++) {
      if (busy) { btns[i].setAttribute('disabled', 'disabled'); } else { btns[i].removeAttribute('disabled'); }
    }
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  /* ---------- summary rendering ---------- */
  function setAll(selector, text) {
    var els = document.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) els[i].textContent = text;
  }

  function updateSummary(cart) {
    var fmt = moneyFormat();
    var sub = cart.original_total_price;
    var tot = cart.total_price;
    var saved = sub - tot;

    setAll('[data-dc-subtotal]', formatMoney(sub, fmt));
    setAll('[data-dc-total]', formatMoney(tot, fmt));
    setAll('[data-dc-discount]', '-' + formatMoney(Math.max(0, saved), fmt));

    var rows = document.querySelectorAll('[data-dc-discount-row]');
    for (var i = 0; i < rows.length; i++) rows[i].classList.toggle('is-hidden', saved <= 0);

    /* rebuild chips: one per unique code (cart-level or line-level), plus
       non-removable chips for automatic cart-level discounts */
    var seen = {};
    var codes = [];
    (cart.cart_level_discount_applications || []).forEach(function (a) {
      if (a.type === 'discount_code' && a.title && !seen[a.title.toLowerCase()]) {
        seen[a.title.toLowerCase()] = 1;
        codes.push(a.title);
      }
    });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var a = al.discount_application;
        if (a && a.type === 'discount_code' && a.title && !seen[a.title.toLowerCase()]) {
          seen[a.title.toLowerCase()] = 1;
          codes.push(a.title);
        }
      });
    });
    var html = codes.map(function (title) {
      var t = escapeHtml(title);
      return '<span class="cdc-chip" data-dc-chip>' + t +
        '<button type="button" class="cdc-chip__remove" data-dc-remove data-dc-code="' + t + '" aria-label="Remove discount">&times;</button></span>';
    }).join('');
    html += (cart.cart_level_discount_applications || []).filter(function (a) { return a.type !== 'discount_code'; })
      .map(function (a) { return '<span class="cdc-chip" data-dc-chip>' + escapeHtml(a.title || '') + '</span>'; }).join('');
    var wraps = document.querySelectorAll('[data-dc-applied]');
    for (var j = 0; j < wraps.length; j++) wraps[j].innerHTML = html;
  }

  /* ---------- apply / remove ---------- */
  /* Returns true (applied), false (rejected), or null (can't tell) */
  function codeStatus(cart, code) {
    var codes = cart && cart.discount_codes;
    if (!codes || !codes.length) return null;
    for (var i = 0; i < codes.length; i++) {
      if (codes[i].code && codes[i].code.toLowerCase() === code.toLowerCase()) {
        return codes[i].applicable !== false;
      }
    }
    return null;
  }

  /* On the /cart page the line items are server-rendered into the page
     itself, so a full reload is the reliable way to show the new state. */
  function onCartPage() {
    return !!document.getElementById('cart_form');
  }

  /* Re-fetch the drawer's server-rendered content so line prices,
     chips and the summary all reflect the new discount state. */
  function refreshDrawer() {
    return fetch('/cart?view=ajax&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tpl = doc.querySelector('template[data-html="content"]');
        if (!tpl) return;
        /* the theme renders the drawer twice (desktop + mobile header):
           update EVERY content container, not just the first ID match */
        var targets = document.querySelectorAll('#ajax-cart__content, [data-ajax-cart-content]');
        for (var i = 0; i < targets.length; i++) targets[i].innerHTML = tpl.innerHTML;
      })
      .catch(function () { /* keep JS-updated summary if re-render fails */ });
  }

  /* Shopify gift cards are 16-20 character alphanumeric codes. They are a
     PAYMENT method, not a discount — the Cart API always rejects them, and
     they can only be redeemed at checkout. Detect them so we can save the
     code for checkout instead of calling it invalid. */
  function looksLikeGiftCard(code) {
    return /^[a-z0-9]{16,20}$/i.test(code.replace(/\s+/g, ''));
  }

  function postDiscount(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: value })
    });
  }

  function finish(cart, code, fromFallback) {
    var status = codeStatus(cart, code);
    if (status === true) {
      updateSummary(cart);
      if (onCartPage()) { window.location.reload(); return; }
      return refreshDrawer().then(function () { setMsg('Discount applied!', true); });
    } else if (status === false) {
      if (looksLikeGiftCard(code)) {
        /* Gift cards are a payment method — Shopify only redeems them on the
           checkout page, and no storefront mechanism can pre-apply them. */
                setMsg('Gift cards are redeemed at checkout, enter this code in the “Discount code or gift card” field after pressing the ‘Checkout’ button.', true);
        return;
      }
      setMsg('This code isn’t valid or doesn’t apply to your cart.', false);
    } else if (fromFallback) {
      setMsg('Code saved — it will be applied at checkout if valid.', true);
      updateSummary(cart);
    } else {
      /* couldn't verify via Cart API — legacy fallback */
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .then(getCart)
        .then(function (cart2) { finish(cart2, code, true); });
    }
  }

  function apply(box) {
    var input = box.querySelector('[data-dc-input]');
    var code = input ? (input.value || '').trim() : '';
    if (!code) { setMsg('Enter a discount code first.', false); return; }
    setBusy(true);
    setMsg('Checking…');
    postDiscount(code)
      .then(getCart, getCart)
      .then(function (cart) { return finish(cart, code, false); })
      .catch(function () { setMsg('Couldn’t apply the code — please try again.', false); })
      .then(function () { setBusy(false); });
  }

  function removeDiscount() {
    setBusy(true);
    setMsg('Removing…');
    postDiscount('')
      .then(getCart, getCart)
      .then(function (cart) {
        updateSummary(cart);
        var stillApplied = (cart.cart_level_discount_applications || []).some(function (a) { return a.type === 'discount_code'; }) ||
          (cart.items || []).some(function (it) {
            return (it.line_level_discount_allocations || []).some(function (a) {
              return a.discount_application && a.discount_application.type === 'discount_code';
            });
          });
        if (!stillApplied && onCartPage()) { window.location.reload(); return; }
        return refreshDrawer().then(function () {
          setMsg(stillApplied ? 'Couldn’t remove the code — please try again.' : 'Discount removed.', !stillApplied);
        });
      })
      .catch(function () { setMsg('Couldn’t remove the code — please try again.', false); })
      .then(function () { setBusy(false); });
  }

  /* ---------- keep summary in sync with any cart change (qty, item remove) ---------- */
  var CART_URL = /\/cart\/(add|change|update|clear)/;
  var syncTimer = null;
  function sync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      getCart().then(updateSummary).catch(function () { /* noop */ });
    }, 250);
  }
  if (window.fetch) {
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var p = origFetch.apply(this, args);
      try {
        var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (CART_URL.test(url)) p.then(function (res) { sync(); return res; });
      } catch (e) { /* noop */ }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      this._dcUrl = u;
      return origOpen.apply(this, arguments);
    };
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (xhr._dcUrl && CART_URL.test(String(xhr._dcUrl))) {
        xhr.addEventListener('load', function () { sync(); });
      }
      return origSend.apply(this, arguments);
    };
  }

  /* ---------- events (delegated) ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var rm = e.target.closest('[data-dc-remove]');
    if (rm) { removeDiscount(); return; }
    var btn = e.target.closest('[data-dc-apply]');
    if (btn) {
      var box = btn.closest('[data-dc]');
      if (box) apply(box);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.matches && t.matches('[data-dc-input]')) {
      e.preventDefault(); /* stop the drawer form submitting to /cart */
      var box = t.closest('[data-dc]');
      if (box) apply(box);
    }
  });
})();
